// extracted by mini-css-extract-plugin
export default {"register":"_37QYO5_JTg99Ib6b8xe4AS"};